import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { isGroupAdmin, isSuperAdmin } from '../../utils/roles';

/**
 * Group Admin Members page
 *
 * This is a dedicated route for group_admin users.
 * It redirects into the existing Group Management members view (/group-management#members),
 * but gives group admins a stable, role-specific URL to use in navigation and bookmarks.
 */
export default function GroupAdminMembers() {
  const { user, userProfile } = useAuth();

  if (!user) return <Navigate to="/login" replace />;

  const role = userProfile?.role;

  // Super admins should use the full group management experience.
  if (isSuperAdmin(role)) return <Navigate to="/group-management#members" replace />;

  // Members should never see admin member-management pages.
  if (!isGroupAdmin(role)) return <Navigate to="/member-dashboard" replace />;

  return <Navigate to="/group-management#members" replace />;
}


